import React from 'react';
import { useUserIdentityContext } from '../../../../context/UserIdentityContext';
import NotificationFeedOrganism from '../../../organisms/NotificationFeed/NotificationFeedOrganism';
import './MessagesMode.scss';

export interface MessagesModeProps {
  /** Active sphere ID (for context - future enhancement for sphere filtering) */
  activeSphereId: string;
  /** Additional sphere IDs (orbitals) - future enhancement for sphere filtering */
  additionalSphereIds?: string[];
  /** Additional CSS classes */
  className?: string;
}

/**
 * MessagesMode - Displays conversation notifications
 *
 * Reuses the existing NotificationFeedOrganism.
 * Future enhancement: Add conversation-specific filtering.
 */
const MessagesMode: React.FC<MessagesModeProps> = ({
  activeSphereId: _activeSphereId,
  additionalSphereIds: _additionalSphereIds,
  className = '',
}) => {
  const { identityId: currentUserId } = useUserIdentityContext();

  if (!currentUserId) {
    return (
      <div className={`messages-mode messages-mode--error ${className}`}>
        <div className="messages-mode__error">
          <i className="pi pi-exclamation-circle" />
          <span>User not authenticated</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`messages-mode ${className}`}>
      <NotificationFeedOrganism
        userId={currentUserId}
        itemsPerPage={20}
        className="messages-mode__feed"
      />
    </div>
  );
};

export default MessagesMode;
